<template>
  <div
    class="input-wrap"
    :class="{'input-wrap--error': error}"
  >
    <component :is="wrapLabel ? 'label' : 'div'">
      <component
        v-if="label"
        :is="wrapLabel ? 'span' : 'label'"
        :for="id"
        class="input-wrap__label"
      >
        {{label}}&nbsp;{{isRequired ? '*' : ''}}

        <div
      v-if="message"
      class="input-wrap__info"
      :class="{'input-wrap__info--error': error}"
    >
      {{message}}
    </div>
      </component>

      <slot
        :id="id"
        :error="error"
      />

    </component>

  </div>
</template>

<script>
  import validationMessages, {displayMessage} from '../../lib/validationMessages';
  import unique from '../../lib/unique';
  import utils from '../mixins/utils';

  export default {
    mixins: [
      utils.translate,
    ],
    props: {
      label: {
        type: String,
        default: null,
      },
      validations: {
        type: Object,
        default: null,
      },
      // This can be used to override the the logic which determines if the field is required.
      required: {
        type: Boolean,
        default: null,
      },
      validationMessages: {
        type: Object,
        default: null,
      },
      wrapLabel: {
        type: Boolean,
        default: true,
      },
      info: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        id: this.wrapLabel ? null : unique('InputWrap'),
        messages: {
          ...validationMessages,
          ...this.validationMessages,
        },
      };
    },
    computed: {
      isRequired() {
        const hasRequiredProperty = this.validations && this.validations.hasOwnProperty('required');
        return this.required === null ? hasRequiredProperty : this.required;
      },
      error() {
        return this.validations && this.validations.$error;
      },
      validationMessage() {
        if (!this.error) {
          return null;
        }

        const failedValidations = Object
          .entries(this.validations.$params)
          .reduce((accumulator, [key]) => {
            return this.validations[key] ? accumulator : [...accumulator, key];
          }, []);

        // Prioritise "required" over other messages
        const messageKey = failedValidations.includes('required') ? 'required' : failedValidations[0];
        return displayMessage(this.messages[messageKey], this.validations);
      },
      message() {
        return this.validationMessage
          ? this.validationMessage
          : this.info;
      },
    }
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .input-wrap {
  }

  // When we have multiple inputs we want to set height the way
  // how labels and inputs align no matter how long the labels are.
  .form__row {
    .input-wrap {
      display: flex;
      flex-flow: column;

      &__label {
        flex: 1;
      }

      >label {
        display: flex;
        flex-flow: column;
        height: 100%;
        width: 100%;

        .input-text {
          width: 100%;
        }
      }
    }
  }


  .input-wrap__label {
    @include font-label-16;
    display: block;
    margin-bottom: r(8);
    transition: color 0.2s;

    .input-wrap:focus-within & {
      color: $color-green-2025;
    }

    .input-wrap--error &,
    .input-wrap--error:focus-within & {
      color: $color-red;
    }
  }

  .input-wrap__info {
    @include font-body-12;
    margin-top: r(4);

    &--error {
      color: $color-red;
    }
  }
</style>
